<template>
  <div class="ma-4">
    <dor-dialog ref="dor" />

    <ClientNav />
    <v-row dense>
      <v-col cols="12" lg="3" xl="2">
        <ClientSide />
      </v-col>
      <v-col cols="12" lg="9" xl="10">
        <v-card class="pa-2" outlined tile height="100%">
          <v-data-table
            :headers="headers"
            :items="dors"
            :loading="isLoading"
            sort-desc
            loading-text="Loading DOR Forms"
            :search="search"
            height="550"
          >
            <template v-slot:top>
              <v-toolbar flat>
                <v-toolbar-title>DOR</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="search"
                  label="Search"
                  clearable
                  flat
                  solo-inverted
                  hide-details
                  prepend-inner-icon="search"
                  class="desktop"
                ></v-text-field>
                <v-spacer></v-spacer>
                <v-btn color="#2b3990" dark class="mb-2" @click="showDialog">
                  <v-icon left>add</v-icon>
                  Add DOR</v-btn
                >
              </v-toolbar>
              <v-text-field
                v-model="search"
                clearable
                flat
                solo-inverted
                hide-details
                prepend-inner-icon="search"
                label="search"
                class="mobile ml-5 mr-5 mb-3 mt-3"
              ></v-text-field>
            </template>

            <template v-slot:item.actions="{ item }">
              <v-icon small class="mr-2" @click="downloadItem(item)">
                mdi-download
              </v-icon>
              <v-icon small class="mr-2" @click="viewItem(item)">
                mdi-eye
              </v-icon>
              <v-icon small @click="onDeleteItem(item)">
                mdi-delete
              </v-icon>
            </template>

            <template v-slot:no-data>
              <v-btn color="#2b3990" class="white--text" @click="getDORS()"
                >Reset</v-btn
              >
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <Foot />
  </div>
</template>
<script>
/*eslint-disable */
// import moment from 'moment'
import ClientNav from "@/components/ClientNav.vue";
import ClientSide from "@/components/ClientSide.vue";
import DorDialog from "@/components/client/dor/DorDialog";
import { mapState, mapActions, mapGetters } from "vuex";
import Foot from "@/components/Footer.vue";
import download from "downloadjs";

const url = require("../../client_config/config").url;

export default {
  components: { ClientNav, ClientSide, DorDialog, Foot },
  data: function() {
    return {
      headers: [
        {
          text: "DOR Date",
          align: "start",
          sortable: true,
          value: "date",
        },
        { text: "Reporting Staff", value: "reportingStaff" },
        { text: "Reporting Staff Title", value: "staffTitle" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      titleForm: "New DOR",
      search: "",
      gender: ["Male", "Female"],
      clientID: this.$route.params.clientID,
      userID: localStorage.getItem("userID"),

    };
  },

  mounted() {
    this.fetchData();
  },

  computed: {
    ...mapState({
      dors: (state) => state.dor.dors,
    }),

    ...mapGetters("dor", ["isLoading"]),
  },

  methods: {
    ...mapActions("dor", ["getDors", "downloadDOR", "deleteDOR"]),

    viewItem(item) {
      this.$refs.dor.onViewItem(item);
    },

    onDeleteItem(item) {
      let confirmDeletion = confirm(
        "Are you sure you want to remove this DOR?"
      );
      if (confirmDeletion) {
        this.deleteDOR(item._id);
        this.fetchData();
      }
    },

    fetchData() {
      this.getDors(this.clientID);
    },

    async downloadItem(item) {
      const data = {
        dorID: item._id,
        clientID: this.clientID,
      }
      let pdfData = await this.downloadDOR(data);

      let pdfFile = "data:application/octet-stream;base64," + pdfData.data;

      download(pdfFile, "md-dor.pdf", "application/pdf");
    },

    showDialog() {
      this.$store.commit("dor/SET_DIALOG", true);
    },
  },
};
</script>
<style>
@media only screen and (min-width: 768px) {
  .mobile {
    display: none;
  }
}

@media only screen and (max-width: 600px) {
  .desktop {
    display: none;
  }
}
</style>
